export const classNames = (...args: any[]) => args.filter(Boolean).join(' ');
